import * as React from "react";
import { DataTable } from "primereact/datatable";

import { DateColumn } from "./DateColumn";
import { DefaultColumn, TableColumn, TableColumnType, TableDtRefColumn } from "./DefaultColumn/DefaultColumn";
import { LinkColumn } from './LinkColumn';
import { NumberColumn } from "./NumberColumn";


export function chooseColumn(column: TableColumn, dtRef: React.RefObject<DataTable<any> | null>) {
  const typedColumn: TableDtRefColumn = { ...column, dtRef: dtRef };
  switch (column.type) {
    case TableColumnType.date:
      return DateColumn(typedColumn);
    case TableColumnType.number:
      return NumberColumn(typedColumn);
  }
  if(column.url){
    return LinkColumn(typedColumn);
  }
  return DefaultColumn(typedColumn);
}
